import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class ChannelListingSerializer extends ApplicationSerializer {
  attrs = {
    address: { serialize: false },
    data: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'channel-listing': ChannelListingSerializer;
  }
}
